import { useQuery } from "@tanstack/react-query";
import { fetchProducts, fetchProductBySlug, fetchFeaturedProducts, fetchSaleProducts } from "@/lib/api/products";
import { fetchCategories } from "@/lib/api/categories";
import { fetchReviewsByProductId } from "@/lib/api/reviews";

export function useProducts() {
  return useQuery({
    queryKey: ["products"],
    queryFn: fetchProducts,
  });
}

export function useProductBySlug(slug: string) {
  return useQuery({
    queryKey: ["product", slug],
    queryFn: () => fetchProductBySlug(slug),
    enabled: !!slug,
  });
}

export function useFeaturedProducts() {
  return useQuery({
    queryKey: ["products", "featured"],
    queryFn: fetchFeaturedProducts,
  });
}

export function useSaleProducts() {
  return useQuery({
    queryKey: ["products", "sale"],
    queryFn: fetchSaleProducts,
  });
}

export function useCategories() {
  return useQuery({
    queryKey: ["categories"],
    queryFn: fetchCategories,
  });
}

export function useReviews(productId: string) {
  return useQuery({
    queryKey: ["reviews", productId],
    queryFn: () => fetchReviewsByProductId(productId),
    enabled: !!productId,
  });
}
